// js/utils/element_helpers.js
/* jshint esversion: 6 */
"use strict";

/**
 * Utility function to add class on elements
 * @params:
 * {element} str element - The html element.
 * {className} str - class name.
 * @return  - None.
 */
export function elementsAddClass(elements, className) {
    console.log("masuk elementsAddClass utility");
    console.log(elements);
    console.log(className);
    if (elements) {
        elements.forEach(element => {
            if (!hasClass(element, className)) {
                element.classList.add(className);
            }
        });
    }
}

export function elementsRemoveClass(elements, className) {
    console.log("masuk elementsAddClass utility");
    console.log(elements);
    console.log(className);
    if (elements) {
        elements.forEach(element => {
            if (hasClass(element, className)) {
                element.classList.remove(className);
            }
        });
    }
}


export function hasClass(element, className) {
    return element.classList.contains(className);
}

